import { z } from 'zod';

import { CampaignWritableShape } from '../campaign-create/campaign-create';

/**
 * Editing a campaign (`notifications.manage`), accepted only while its status is
 * still editable — the api refuses the write once the walk can have sent
 * anything, because by then some members have already read it.
 *
 * A partial patch, so omitting `translations` means "leave the copy alone"
 * rather than "blank it" — the same reading `NotificationTemplateUpdateSchema`
 * and `UpdateLegalDocumentSchema` both keep.
 */
export const CampaignUpdateSchema = z.object(CampaignWritableShape).partial().strict();

export type CampaignUpdateRequest = z.infer<typeof CampaignUpdateSchema>;
